var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7 16.3409C30.7 15.2773 30.6046 14.2546 30.4273 13.2726H16.3V19.0749H24.3727C24.025 20.9499 22.9682 22.5386 21.3796 23.6023V27.3659H26.2273C29.0637 24.7546 30.7 20.9091 30.7 16.3409Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 31C20.35 31 23.7454 29.6567 26.2272 27.3659L21.3795 23.6024C20.0364 24.5024 18.3182 25.0341 16.3 25.0341C12.3932 25.0341 9.08637 22.3954 7.90677 18.85H2.89542V22.7364C5.36367 27.6387 10.4364 31 16.3 31Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90675 18.8499C7.60675 17.9499 7.43635 16.9886 7.43635 15.9999C7.43635 15.0112 7.60675 14.0499 7.90675 13.1499V9.26355H2.8954C1.8796 11.2886 1.3 13.5795 1.3 15.9999C1.3 18.4203 1.8796 20.7112 2.8954 22.7362L7.90675 18.8499Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 6.96595C18.5022 6.96595 20.4795 7.7227 22.034 9.20905L26.3364 4.90675C23.7387 2.48635 20.3432 1 16.3 1C10.4364 1 5.36367 4.36135 2.89542 9.26365L7.90677 13.15C9.08637 9.6046 12.3932 6.96595 16.3 6.96595Z",
    fill: "#E94235"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.72e71e3b.svg";
export { ForwardRef as ReactComponent };